import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { UPDATE_INVENTORY_STATUS } from "../apiRoutes";
import { toast } from "sonner";

export interface UpdateInventoryStatusItem {
  id?: string;
  _id?: string;
  isDeleted?: boolean;
  packingStatus: string;
  approvedBy: string;
  shipmentDate: string;
  inventoryCheckLists: string[];
}

export interface UpdateInventoryStatusDetailPayload {
  inventoryStatusList: UpdateInventoryStatusItem[];
  note?: string | null;
}

export interface UpdateInventoryStatusDetailResponse {
  status?: number;
  error?: boolean;
  message?: string;
  data?: any;
}

/**
 * Update inventory status — schoolId is passed as a URL param (not in body)
 */
export const useUpdateInventoryStatus = (options?: {
  onSuccess?: (data: UpdateInventoryStatusDetailResponse) => void;
  onError?: (error: any) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * @param variables - { schoolId, payload }
     */
    mutationFn: async ({
      schoolId,
      payload,
    }: {
      schoolId: string;
      payload: UpdateInventoryStatusDetailPayload;
    }): Promise<UpdateInventoryStatusDetailResponse> => {
      const response = await axiosAuth.put(
        `${UPDATE_INVENTORY_STATUS}${schoolId}`,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Inventory Status Updated successfully");
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
